import style from './Activity.module.scss'

export function Activity({ show = false, offset = false }) {
  if (show)
    return <div className={`${style.challenge} ${offset ? style.offset : ''}`} />
  return null
}
